import { defineMessages } from 'react-intl-next';
export default defineMessages({
  emptyStateHeader: {
    defaultMessage: "We couldn't find what you're looking for",
    id: 'embedded-confluence-common.src.content.empty-state-header',
    description: 'The header message in the empty state error screen shown to the user when there is no page to render'
  },
  emptyStateDescription: {
    defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it 😉",
    id: 'embedded-confluence-common.src.content.empty-state-description',
    description: 'The description message in the empty state error screen shown to the user when there is no page to render'
  }
});